const OrderTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="container container-lg orders-tabs-section py-24">
      <div className="row g-3">
        <div className="col-12">
          <div className="orders-tabs" role="tablist" aria-label="Order status">
            <button
              type="button"
              className={`tab-btn ${activeTab === 2 ? "is-active" : ""}`}
              onClick={() => setActiveTab(2)}
              aria-pressed={activeTab === 2}
            >
              Active
            </button>

            <button
              type="button"
              className={`tab-btn ${activeTab === 3 ? "is-active" : ""}`}
              onClick={() => setActiveTab(3)}
              aria-pressed={activeTab === 3}
            >
              Past
            </button>
          </div>
        </div>  
      </div>
    </div>    
  );
};

export default OrderTabs;
